module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_10000_25000.fc68748e.png";